import {
  WorkoutMode,
  WorkoutService,
} from './../../@core/backend/common/services/CalorieFriend/workout.service';
import { IComponentCanDeactivate } from './../../@auth/guards/changes.guard';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { map, takeUntil } from 'rxjs/operators';

import { PatientData } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { FitnessPlan, FitnessPlanData, ProgramTemplateData } from 'app/@core/interfaces/common/CalorieFriend/plan';
import { UsersService } from 'app/@core/backend/common/services/users.service';
import { FitnessPlanDefComponentBase } from 'app/pages/CalorieFriend/FitnessPlans/PlanDef/fitness-plan-def-base.component';
import { Observable } from 'rxjs';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'patient-fitness-plan-view',
  templateUrl: './patient-fitness-plan-view.component.html',
  styleUrls: ['./patient-fitness-plan-view.component.scss'],
})
export class PatientFitnessPlanViewComponent
  extends FitnessPlanDefComponentBase
  implements OnInit {
  constructor(
    private PlanViewPlanService: FitnessPlanData,
    private PlanViewPatientsService: PatientData,
    PlanViewRoute: ActivatedRoute,
    PlanViewFormBuilder: FormBuilder,
    PlanViewDialogService: NbDialogService,
    PlanViewToasterService: NbToastrService,
    PlanViewUsersService: UsersService,
    private PlanViewRouter: Router,
    PlanViewPatientService: PatientData,
    private WorkoutService: WorkoutService,
    programTemplateService: ProgramTemplateData,
  ) {
    super(
      PlanViewRoute,
      PlanViewFormBuilder,
      PlanViewDialogService,
      PlanViewPlanService,
      PlanViewToasterService,
      PlanViewUsersService,
      PlanViewRouter,
      PlanViewPatientService,
      programTemplateService
    );
    this.PlanView = true;
  }

  ngOnInit(): void {
    if (this.PatientID || this.NotificationToken) {
      this.PlanViewPatientsService.get(this.PatientID, this.NotificationToken)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((patient) => {
          this.PatientName = `${patient.firstName} ${patient.lastName}'s View`;
          this.OriginalPatientName = patient.name;
          this.IsPreferredUnitImperial = patient.isPreferredUnitImperial;
        }


        );
    }

    if (this.NotificationToken) {
      const Elements = document.getElementsByClassName('header-container');
      if (Elements?.length > 0) {
        const container: any = Elements[0];
        const Header = container.parentElement.parentElement.parentElement;
        Header.style.visibility = 'hidden';
        Header.style.height = '0px';
      }
    }

    this.PlanIDSubject.subscribe(() => {
      this.PlanViewPlanService.get(this.PlanID).subscribe((data) => {
        this.ThePlan = data;
        //this.PlanID = data.id;
        this.PatientID = data.patientID;

        super.ngOnInit();
      },
        (err) => {
          let plansList;
          plansList = this.PlanViewPlanService.listByGuid(
            this.NotificationToken
          );
          plansList.subscribe((data) => {
            let plans = data.items;
            let newId = '';
            const activePlan: FitnessPlan = plans.find((plan) => plan.active);

            if (activePlan) {
              newId = activePlan.id.toString();
            } else {
              if (plansList.length > 0) {
                plans.sort((p1, p2) => p2.id - p1.id);
                newId = plans[0].id;
              }
            }

            if (newId !== '') {
              window.location.href = `/PatientView/Patient/${this.NotificationToken}/Workout/${newId}`;
            } else {
              window.location.href = `/PatientView/calendar/${this.NotificationToken}`;
            }
          });
        });
    });
  }

  canDeactivate(): boolean | Observable<boolean> {
    return !(this.WorkoutService.workoutMode.value == WorkoutMode.Workout);
  }

  onDayChanged(event: MatTabChangeEvent) {
    if (event.index < 0) return;
    this.WorkoutService.dayId.next(this.TheDays[event.index].id);
  }
}
